import { Command } from 'commander'

import { GenerateReadmeCommand } from './generate'
import { ServeReadmeCommand } from './serve'

const readmeDomain = new Command('readme')
readmeDomain.addCommand(GenerateReadmeCommand())
ServeReadmeCommand(readmeDomain)
export default readmeDomain
